import React from 'react'
import styled from 'styled-components'
import {GridContainer, GridItem, currentMedia} from '../../../../../styledComponents/ResponsiveConvenience'
import {RowFlexContainer} from '../../../../../styledComponents/FlexComponents'
import {DisplayItemLabelDiv} from '../../../../../styledComponents/DisplayItem'
import {Colors, FontWeights} from '../../../../../styledComponents/Constants'
import {Box} from '@mui/material'

interface Props {
    title: string
    items: string[]
}

const NatResidentApplicationDetailConfirmItem: React.FC<Props> = props => {
    return <ItemDiv>
        <GridContainer alignItems={'flex-start'}>
            <GridItem over={3}><DisplayItemLabelDiv><Box mr={'5px'}>{props.title}</Box></DisplayItemLabelDiv>
            </GridItem>
            <GridItem over={9}>
                {props.items.map((item, i) =>
                    <RowFlexContainer key={i}><TextContents>{item}</TextContents></RowFlexContainer>)}
            </GridItem>
        </GridContainer>
    </ItemDiv>
}

NatResidentApplicationDetailConfirmItem.displayName = 'NatResidentApplicationDetailConfirmItem'
export default NatResidentApplicationDetailConfirmItem

const ItemDiv = styled.div`
  background-color: ${Colors.Surface};
 ${currentMedia.lessThan('sp')`
    margin: 0px -15px;
  `}
  padding: 20px 15px 20px 15px;
`
const TextContents = styled.div`
  font-weight: ${FontWeights.Bold};
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`